import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

    TagsEmpty:{
        k: "tags.empty.title",
        v: "No Tags Found"
    },
    TagsEmptyDescription:{
        k:"tags.empty.desription",
        v:""
    }
});


// WEBPACK FOOTER //
// ./src/panels/refineTag/RefineBundleTag.labels.ts